<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">巡更路线名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>

      <div style="margin-left: 14px;color: #666666;margin-bottom: 20px;">巡更路线</div>

      <div>
        <div style="margin-left: 14px;">
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in formData.patrolRouteDetailList"
              :key="index">
              <div class="textBox">
                <b class="red">*</b>
                <span class="line-text">巡更点：</span>
              </div>
              <el-select v-model="item.patrolDeviceCode" filterable size="small" style="width: 280px" placeholder="请输入关键词查询">
                <el-option v-for="item in patrolPointList" :key="item.deviceCode"
                           :label="item.name" :value="item.deviceCode">
                </el-option>
              </el-select>
              <div class="textBox">
                <!--<b class="red">*</b>-->
                <span class="line-text">巡更时间间隔：</span>
              </div>
              <el-input v-model="item.patrolTimeInterval" size="small" style="width: 280px;align-items: center;height: 0.2rem" >
                <template slot="append">分钟</template>
              </el-input>
              <i class="el-icon-remove-outline" style="line-height: 0.2rem;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removePatrolRouteItem(index)" v-if="index > 0"></i>
              <i class="el-icon-circle-plus-outline" style="line-height: 0.2rem;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addPatrolRouteItem(index)" v-if="index === formData.patrolRouteDetailList.length - 1"></i>
            </el-timeline-item>
          </el-timeline>
        </div>

      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/KeepWatch'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'patrol-route-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧巡更',
          name: 'patrol-point-manage'
        }, {
          value: '巡更路线'
        }],
        mainTitle: '添加巡更路线',
        subheading: '',

        patrolPointList: [],

        formData: {
          name: '',
          patrolRouteDetailList: [
            {
              patrolDeviceCode: '',
              patrolTimeInterval: '',
            }
          ],
        },

      }
    },
    created () {
      this.getResponsiblePersonList()
    },
    methods: {
      // 获取巡更点列表
      getResponsiblePersonList () {
        this.$axios.post(api.getPatrolPointList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.patrolPointList = res.data.data
            }
          })
          .catch(errorHandler('获取巡更点列表失败'))
      },

      // 增加巡更点
      addPatrolRouteItem (index) {
        if (!this.formData.patrolRouteDetailList[index].patrolDeviceCode) {
          nError('请先选择当前巡更点')
          return false
        }
        let obj = {
          patrolDeviceCode: '',
          patrolTimeInterval: '',
        }
        this.formData.patrolRouteDetailList.push(obj)
      },

      // 删减巡更点
      removePatrolRouteItem (index) {
        this.formData.patrolRouteDetailList.splice(index, 1)
      },

      toManagePage () {
        this.$router.push({
          name: 'patrol-route-manage'
        })
      },

      confirm () {
        if (!this.formData.name) {
          nError('请输入巡更路线名称')
          return false
        }
        let patrolRouteDetailCodeList = []
        let reqData = {
          name: this.formData.name,
          patrolRouteDetailList: []
        }
        this.formData.patrolRouteDetailList.map(item => {
          if (patrolRouteDetailCodeList.indexOf(item.patrolDeviceCode) === -1) {
            patrolRouteDetailCodeList.push(item.patrolDeviceCode)
            reqData.patrolRouteDetailList.push(item)
          }
        })
        reqData.patrolRouteDetailList.map((v, i) => {
          if (i === 0) {
            v.previousPatrolPointCode = ''
          } else {
            let preIndex = i - 1
            v.previousPatrolPointCode = this.formData.patrolRouteDetailList[preIndex].patrolDeviceCode
          }
	v.nodeIndexValue = i + 1;
        })
        this.$axios.post(api.addPatrolRoute, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toManagePage()
      }
    },
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 28px;
    line-height: 40px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .invoice-tax-rate-add {
    .el-switch {
      height: 30px;
    }
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }

    .el-timeline {
      .el-timeline-item {
        .el-timeline-item__tail {
          top: 10px;
        }
        .el-timeline-item__node--normal {
          top: 10px;
        }
        .el-timeline-item__content {
          display: flex;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/KeepWatch/PatrolRoute/PatrolRouteAdd.vue